import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-invoices',
  templateUrl: './admin-invoices.component.html',
  styleUrls: ['./admin-invoices.component.scss']
})
export class AdminInvoicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
